import { render } from "./SpecialitiesSection.vue?vue&type=template&id=3be467eb"
import script from "./SpecialitiesSection.vue?vue&type=script&lang=js"
export * from "./SpecialitiesSection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__